//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";

import IGoalsWrapper from "./goals-wrapper.d";
import { findGoal } from "@util/goal.util";

export class BaseGoalComponent<S extends IGoalsWrapper.State> extends React.PureComponent<
  IGoalsWrapper.Props,
  S
> {
  private goalId: string;

  constructor(props: IGoalsWrapper.Props, goalId: string) {
    super(props);

    this.goalId = goalId;
    this.onToggle = this.onToggle.bind(this);
  }

  protected findGoal(props: IGoalsWrapper.Props = this.props): ISchema.IGoal | null {
    return findGoal(props.org.userGoals, this.goalId);
  }

  protected asInput = (goal: ISchema.IGoal): ISchema.IGoalInput => {
    // goal input doesn't have the specific options that the goal has
    const { specificOptions, ...copiedOptions } = goal.options;

    const goalInput = { ...goal, options: copiedOptions };

    return goalInput;
  };

  protected findGoalInput = (
    props: IGoalsWrapper.Props = this.props,
  ): ISchema.IGoalInput | null => {
    const goal = this.findGoal(props);
    return goal && this.asInput(goal);
  };

  protected onToggle(_event: any, isInputChecked: boolean): void {
    this.setState({ selected: isInputChecked });

    this.mutateOnToggle(isInputChecked);
  }

  protected mutateOnToggle(_isInputChecked: boolean): void {
    // Noop, subclasses should implement
  }
}
